import useNswagClient from '../../hooks/api/useNswagClient';
import { useContext, useState } from 'react';
import { UserContext } from '../../components/shared/useUser';
import { ConfigurationName } from '../../enums/ConfigurationName';

const usePodPredictionReadonlyConfiguration = () => {
  const { selectedStore } = useContext(UserContext);
  const { getConfiguration } = useNswagClient();
  const [isPodPredictionReadonlyEnabled, setIsPodPredictionReadonlyEnabled] = useState<boolean>(false);

  const getPodPredictionReadonlyConfiguration = () => {
    getConfiguration(
      ConfigurationName.PodPredictionReadonlyEnabled,
      selectedStore?.storeNumber ?? '',
      selectedStore?.franchiseName ?? '',
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ).then((res: any) => {
      const value = res?.data?.value;
      setIsPodPredictionReadonlyEnabled(
        value === true || value === 'true' || value === '1',
      );
    });
  };

  return {
    isPodPredictionReadonlyEnabled,
    getPodPredictionReadonlyConfiguration,
  };
};

export default usePodPredictionReadonlyConfiguration;
